module.exports = {
  name: 'drawer-no-scroll',
  variantClass: 'drawer-variant no-scroll',
  transition: 'drawer',
  getBodyHeight: (headerH, footerH, windowH) => null
}